import styles from "./css/MoreButton.module.css";
import { ReactComponent as MoreIcon } from "../../img/iconImgAllMore.svg";

interface MoreButtonProps {
  color?: string;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export default function MoreButton(props: MoreButtonProps) {
  function handleOnClickButton(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
    props.onClick(e);
  }

  return (
    <>
      <div
        className={styles.button}
        onClick={handleOnClickButton}
        style={{
          color: props.color ?? "var(--icon-secondary-color)",
        }}
      >
        <MoreIcon
          className={styles.icon}
          style={{
            width: "24px",
            height: "24px",
          }}
        />
      </div>
    </>
  );
}
